import { DestinationWithStreamMeta } from '@anm/components/stream/StreamItem';
import getBrokenDestinations from '@anm/components/stream/destination_management/helpers/getBrokenDestinations';
import useAddDestination from '@anm/components/stream/destination_management/hooks/useAddDestination';
import { Urls } from '@anm/components/stream/destination_management/types';
import capitalize from '@anm/helpers/string/capitalize';

type FilterDestinationProps = {
  waveUrls: Urls;
  isOwnDestinations: boolean;
  destinationsList: DestinationWithStreamMeta[];
  userId?: string;
};

export const useFilterDestinations = ({
  userId,
  waveUrls,
  isOwnDestinations,
  destinationsList
}: FilterDestinationProps) => {
  const [destinationsWithErrors] = getBrokenDestinations(destinationsList);
  const [list, renderConnectToFacebookModal] = useAddDestination({
    isReconnect: true,
    ...waveUrls
  });

  const checkedDestinations = destinationsList.map(d => {
    const isDisconnected = destinationsWithErrors?.some(e => e.id === d.id);
    const capitalizedNetwork = capitalize(d.network, true);
    const title = d.kind ? `${capitalizedNetwork} ${d.kind}` : capitalizedNetwork;

    return {
      ...d,
      isDisconnected,
      ...(isDisconnected && {
        onConnect: () => list.find(t => t.kind === d.kind && t.network === d.network)?.onClick?.(title)
      })
    };
  });

  const guestDestinations = checkedDestinations.filter(d => d.user_id && d.user_id !== userId);
  const ownDestinations = checkedDestinations.filter(d => !d.user_id || d.user_id === userId);
  const destinations = isOwnDestinations ? ownDestinations : guestDestinations;

  return [destinations, renderConnectToFacebookModal] as const;
};
